import psHttp from '@patsnap/common-ps-http';
import { DRAFTING_URI } from '@/constants/base-url';
import type { ApiResponse } from '@/types/project';

export interface SourceReferenceItem {
    ref: string;
    status: 'available' | 'unavailable' | 'invalid';
    source_id: string | null;
    source_kind: 'attachment' | 'editor_document' | null;
    resource_id: string | null;
    file_name: string | null;
    snapshot_id: string | null;
    text: string | null;
    paragraph_number: number | null;
    page_number: number | null;
    source_data_id: string | null;
    error: string | null;
}

export interface SourceReferenceSnapshot {
    source_id: string;
    source_kind: 'attachment' | 'editor_document';
    resource_id: string;
    file_name: string;
    snapshot_id: string;
    paragraphs: SourceReferenceItem[];
}

/** 项目权限下的批量解析和冻结来源读取契约，供 composition root 注入。 */
export interface SourceReferencesApi {
    resolve(projectId: string, refs: string): Promise<{ items: SourceReferenceItem[] }>;
    getSource(projectId: string, sourceId: string): Promise<SourceReferenceSnapshot>;
}

export const sourceReferencesApi: SourceReferencesApi = {
    async resolve(projectId, refs) {
        const response = await psHttp<ApiResponse<{ items: SourceReferenceItem[] }>>({
            url: `${DRAFTING_URI}/api/projects/${encodeURIComponent(projectId)}/source-references/resolve`,
            method: 'POST', data: { refs },
        });
        return response.data.data;
    },
    async getSource(projectId, sourceId) {
        const response = await psHttp<ApiResponse<SourceReferenceSnapshot>>({
            url: `${DRAFTING_URI}/api/projects/${encodeURIComponent(projectId)}/source-references/${encodeURIComponent(sourceId)}`,
            method: 'GET', headers: { 'Cache-Control': 'no-cache' },
        });
        return response.data.data;
    },
};
